<template>
  <AdminModal
    :is-open="open"
    :modal-title="modalTitle"
    :close="modalClose"
    :confirm="confirm"
    :confirm-button-title="confirmButtonTitle"
    name="paymentLinkModal"
  >
    <div class="container">
      <div class="mb-3">
        <span>결제 상품 추가</span>
        <div class="float-end">
          <input
            class="form-check-input"
            type="checkbox"
            id="selectAll"
            v-model="selectAll"
          />
          <label class="form-check-label px-1" for="selectAll">
            전체 선택
          </label>
        </div>
      </div>
      <div class="col-md-12 card">
        <div class="card-body input-list">
          <div v-for="(product, index) in products" class="p-1" :key="index">
            <input
              class="form-check-input"
              type="checkbox"
              :id="product.index"
              :value="product.id"
              v-model="selectedProducts"
            />
            <label class="form-check-label px-1" :for="product.id">
              {{product.title}}
            </label>
          </div>
        </div>
      </div>
    </div>
    <div class="container pt-2">
      <label for="memo" class="form-label">메모</label>
      <textarea class="form-control" id="memo" rows="3" v-model="memo"></textarea>
    </div>
  </AdminModal>
</template>

<script>
import api from "@/api/api";
import AdminModal from "@/components/modals/AdminModal.vue";

export default {
  components: {AdminModal},
  props: ['open', 'modalClose','id','reload'],
  data() {
    return {
      products: [],
      selectedProducts: [],
      memo: "",
      selectAll: false,
      activated: false,
      alreadyPaidLink: false,
      createdAt: null,
      deletedAt: null,
      expiredAt: null,
      linkKey: "",
    }
  },
  mounted() {
    this.getData()
    console.log(this.id + "ddd")
    if (this.id !== null) {
      this.getPaymentLink()
    }
  },
  computed:{
    modalTitle () {
      return this.id === null ? '결제 링크 등록' : '결제 링크 상세'
    },
    confirmButtonTitle() {
      return this.id === null ? '등록' : '수정'
    }
  },
  watch: {
    selectAll(){
      if(this.selectAll) {
        this.selectedProducts = this.products.map(product => product.id)
      } else if (this.selectedProducts.length === this.products.length){
        this.selectedProducts = []
      }
    },
    selectedProducts(){
      if (this.selectedProducts.length === this.products.length){
        this.selectAll = true
      } else {
        this.selectAll = false
      }
    }
  },
  methods: {
    confirm(){
      if (this.deletedAt === null) {
        if(this.id === null) this.store()
        else this.update()
      } else {
        alert("삭제된 상품은 수정할 수 없습니다.")
      }
    },
    getPaymentLink(){
      api.paymentLink.detail({id: this.id}, response => {
        const data = response.data
        console.log(data)
        this.selectedProducts = data.products.map(product => product.id)
        this.memo = data.memo
        this.activated = data.activated
        this.alreadyPaidLink = data.alreadyPaidLink
        this.createdAt = data.createdAt
        this.deletedAt = data.deletedAt
        this.expiredAt = data.expiredAt
        this.linkKey = data.linkKey
      }, err => {
        alert(err.message)
      })
    },
    validate(){
      if (this.selectedProducts.length == 0) {
        alert("결제 상품을 추가해주세요")
        return false
      }
      
      return true
    },
    update(){
      if (this.validate()){
        const params = {
          id: this.id,
          memo: this.memo,
          selectedProducts : this.selectedProducts.toString()
        }
        api.paymentLink.update(params,() => {
          this.reload()
          this.modalClose()
        }, error => {
          alert(error.message)
        })
      }
    },
    store(){
      if (this.validate()){
        const params = {
          memo: this.memo,
          selectedProducts : this.selectedProducts.toString()
        }
        api.paymentLink.save(params, () => {
          this.reload()
          this.modalClose()
        }, error => {
          alert(error.message)
        })
      }
    },
    getData(){
      api.product.data(null, (response) => {
        this.products = response.data
      }, (err) => {
        console.log(err)
      })
    }
  }
}
</script>

<style scoped>
.input-list{
  height: 10rem;
  overflow-y: auto;
}
.card-title-body{
  
}
.modal {
  transition: opacity 0.25s ease;
}
.show{
  display: block !important;
}
ul{
  padding-left: 0;
}
</style>